export default __webpack_public_path__ + "static/media/type_05_drk@60.64d0f736.svg";